import { refreshIntervals } from "@/consts/swr"
import useSWR from "swr"
import { getPublicSelfCheckIn } from "@/api/nextme/self-check-ins"
import { SelfCheckIn } from "@/api/interface/self-check-in"

export default function usePublicSelfCheckIn(sciId: string) {
  const {
    data: publicSelfCheckIn,
    error,
    isValidating,
    mutate,
  } = useSWR(
    `/nextme/waiting-room/${sciId}`,
    () => (sciId ? getPublicSelfCheckIn(sciId) : ({} as SelfCheckIn)),
    {
      dedupingInterval: 10000,
      fallbackData: {} as SelfCheckIn,
      refreshInterval: refreshIntervals.verySlow,
      revalidateOnFocus: false,
    }
  )

  return {
    error,
    isValidating,
    publicSelfCheckIn,
    mutatePublicSelfCheckIn: mutate,
  }
}
